import { render, staticRenderFns } from "./HomeBoxIndoor.vue?vue&type=template&id=217ce23e"
import script from "./HomeBoxIndoor.vue?vue&type=script&lang=js"
export * from "./HomeBoxIndoor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports